import { createTheme } from '@air/marketing-primitives';

export const worthlessStudiosTheme = createTheme('worthless-studios-theme', {
  fonts: {
    copy: 'Menlo, Inter, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
    display:
      'Inter, system-ui, -apple-system, Segoe UI, Roboto, Ubuntu, Cantarell, Noto Sans, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
    monospace:
      'Menlo, Consolas, Roboto Mono, "Ubuntu Monospace", "Noto Mono", "Oxygen Mono", "Liberation Mono", monospace',
  },
});
